import { Injectable,Inject, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { appsettings,enumUIFeatureView, enumUIAction, enumUIView } from '../../app-settings';
import { alertinfo,  StaffData, showLiveLocation } from './home';
import { SharedCheckAlertData,staffresidentdata,NearestStaffdata, getResStaffCurrentLocation } from '../../api';
import { DrawLocation,groupBy,set_IsLocationReportChange,getFeatureNeedtoShow} from '../../app-general';
import { RollbarService } from '../../rollbar';
import * as Rollbar from 'rollbar';
import * as socketIo from 'socket.io-client';
import { AlertSharedService } from '../../_services/index';
import { AppComponent } from '../../app.component';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})

export class HomeService {
  
  public toggleHomeMenuNav: EventEmitter<any> = new EventEmitter();  

  showLiveLocationUrl = appsettings.API_ENDPOINT+'StaffViewNews/showLiveLocation';

  getNotificationByAlertUrl = appsettings.API_ENDPOINT + 'MapViewNews/getNotificationByAlert';
  renotifyAlertUrl = appsettings.API_ENDPOINT + 'MapViewNews/renotifyAlert';
  getRenotifyDataUrl = appsettings.API_ENDPOINT+'MapViewNews/getRenotifyData';
  getNearestStaffForAlertUrl = appsettings.API_ENDPOINT + 'MapViewNews/getNearestStaffForAlert';
  
  getMapDetailsUrl = appsettings.API_ENDPOINT+'TechnologyOverlayViewV2s/getHomeMapDetails';
  getoutdoorunitsUrl=  appsettings.API_ENDPOINT+'TechnologyOverlayViewV2s/isoutdoorunits';

  private checkinternetaccess = appsettings.URLinfo+'checkinternetaccess';

  alertinfo: alertinfo[];
  SiteId = '1';
  CheckAlertData: SharedCheckAlertData;  
  _staffresidentinfo;
  constructor(private http: HttpClient, private alertSharedService: AlertSharedService,public apiService: ApiService,
    @Inject(RollbarService) private rollbar: Rollbar) { 

      
    }

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }
  
  getRenotifyData(data): Observable<StaffData[]> 
  {                   
    return this.http.post<StaffData[]>(this.getRenotifyDataUrl, data)        
  }

  getNotificationByAlert(data): Observable<StaffData[]> {    
    return this.http.post<StaffData[]>(this.getNotificationByAlertUrl, data)
  }

  getNearestStaffForAlert(item): Observable<NearestStaffdata[]> {    
    return this.http.post<NearestStaffdata[]>(this.getNearestStaffForAlertUrl, item)
  }

  renotifyAlert(item): Observable<NearestStaffdata[]> {        
    return this.http.post<NearestStaffdata[]>(this.renotifyAlertUrl, item)
  }

  showLiveLocation(LiveItem): Observable<staffresidentdata[]> {    
    return this.http.post<staffresidentdata[]>(this.showLiveLocationUrl,LiveItem)
  }
  
  getMapDetails(mapdata): Observable<StaffData[]> { 
    return this.http.post<StaffData[]>(this.getMapDetailsUrl,mapdata) 
  }
  
  getoutdoorunits(data): Observable<StaffData[]> {    
    return this.http.post<StaffData[]>(this.getoutdoorunitsUrl, data)
  }  
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      throw new Error("home.service.ts - " + operation + "() - " + error.message);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  // Map Live 
  isMapLivetpushSocketDownloaded = 0;  

  SubscribeforLocationChangeData() {
    try 
    {
      var _apiService = this.apiService;
            
      var liveitem : showLiveLocation = 
        { 
          siteId: this.SiteId, 
          authKey: localStorage.getItem("Authkey") 
        }
      this.showLiveLocation(liveitem).subscribe((LiveresponseInfo: any[]) => 
      {
               
        if (getFeatureNeedtoShow(enumUIFeatureView.Location, enumUIAction.Location_RTLS_Staff) == enumUIView.Show ||
           getFeatureNeedtoShow(enumUIFeatureView.Location, enumUIAction.Location_RTLS_Resident) == enumUIView.Show )
        {             
        var _data : getResStaffCurrentLocation = 
        { 
          siteId: this.SiteId, 
          authKey: localStorage.getItem("Authkey") 
        };
        _apiService.getStaffResidentCurrentLocation(_data).subscribe((staffresidentinfo: staffresidentdata[]) => 
        {

          _apiService.getAllRooms(_data).subscribe((roomdetailsdatainfo: any[]) => 
          {

            var RoomDetailsinfo = groupBy(roomdetailsdatainfo, 'RoomId');
          this.alertSharedService.changeSharedRoomDetailsBased(RoomDetailsinfo);

	        this.alertSharedService.changeSharedResidentStaffBased(staffresidentinfo);

          var ResidentsStaff = groupBy(staffresidentinfo, 'RoomId');
          this.alertSharedService.changeResidentStaff(ResidentsStaff);

         
           this.alertSharedService.currentSharedResidentStaffBased().subscribe((SharedResidentStaffBasedDetails) => { this._staffresidentinfo = SharedResidentStaffBasedDetails });

            if (this.isMapLivetpushSocketDownloaded == 0) {
              this.ConnectLocationChangeSocket();
              this.isMapLivetpushSocketDownloaded = 1;
            }
            else {
              this.ConnectLocationChangeSocket();
            }
          });
        
          }); // end
        }

      });  
    }
    catch (err) {
      throw new Error('home.service.ts' + ' - SubscribeforLocationChangeData() - ' + err.message);
    }
  }
  
   /** connect to socket */
   ConnectLocationChangeSocket() {
    try {
      var userChannel = "LTCEventData";
      var usersiteid = 2222;
            
            var _sharedService = this.alertSharedService;
            var _apiService = this.apiService;

            /** connect to socket url with option */
            //this.mapsocket = socketIo('http://' + appsettings.SOCKET_IP + ':3001/', { secure: true, 'forceNew': true, query: "registrationKey=3A3CD974A53E49ba&siteid=" + usersiteid + "&userChannel=" + userChannel });
            console.log("socketUrl home :" + AppComponent.socketUrl);
            AppComponent.mapsocket = socketIo( AppComponent.socketUrl+'/', { secure: true, 'forceNew': true, query: "registrationKey=3A3CD974A53E49ba&siteid=" + usersiteid + "&userChannel=" + userChannel });
            

            /** connect to socket */
            AppComponent.mapsocket.on('connect', (data) => {
              console.log(userChannel + " Connected");
              AppComponent.mapsocket.emit('subscribe', { channel: userChannel });
            });

            /** reconnect to socket */
            AppComponent.mapsocket.on('reconnecting', function (data) {
              console.log("reconnecting");
            });

            /** Referesh the alertlist when socket emit */
            AppComponent.mapsocket.on('message', onLocationChangeEmit);

    }
    catch (err) {
      throw new Error('home.service.ts' + ' - ConnectLocationChangeSocket() - ' + err.message);
    }

    /** Refresh the alertlist when socket emit */
    function onLocationChangeEmit(data) {
      try {
        set_IsLocationReportChange(1, _sharedService);
        


        var Residents;
        Residents = AppComponent.SharedResidentStaffDetails;

        var RoomDetails;
        RoomDetails = AppComponent.SharedRoomBasedDetails;


        var _gStaffResidentData = AppComponent.SharedResidentStaffBasedDetails;
       
        if(data != null)
        {
          if(data != "")
          {

            var jObj = JSON.parse(data);

            if(jObj != null)
            {
                var tagId = jObj['Value']['TagId'];

               var objstaffresident = _gStaffResidentData.filter(function (e1) {
                  return e1.TagId == tagId;
                });

                if(objstaffresident.length == 0)
                {

                  var _data : getResStaffCurrentLocation = 
                  { 
                    siteId: this.SiteId, 
                    authKey: localStorage.getItem("Authkey") 
                  };
                  _apiService.getStaffResidentCurrentLocation(_data).subscribe((staffresidentinfo: staffresidentdata[]) => 
                  {

                    _apiService.getAllRooms(_data).subscribe((roomdetailsdatainfo: any[]) => 
                    {
                        var RoomDetailsinfo = groupBy(roomdetailsdatainfo, 'RoomId');
                        _sharedService.changeSharedRoomDetailsBased(RoomDetailsinfo);

                        _sharedService.changeSharedResidentStaffBased(staffresidentinfo);

                        var ResidentsStaff = groupBy(staffresidentinfo, 'RoomId');
                        _sharedService.changeResidentStaff(ResidentsStaff);

                        Residents = AppComponent.SharedResidentStaffDetails;
                        RoomDetails = AppComponent.SharedRoomBasedDetails;
                        _gStaffResidentData = AppComponent.SharedResidentStaffBasedDetails;

                        loadliveData(data,_sharedService,Residents,RoomDetails,_gStaffResidentData);
                    });
                
                  }); // end

                }
                else
                {
                  loadliveData(data,_sharedService,Residents,RoomDetails,_gStaffResidentData);
                }
           }
            
          }
        }
      }
      catch (err) {
        throw new Error('home.service.ts' + ' - onLocationChangeEmit() -' + err.message);
      }
    }
  }
}

function loadliveData(data,_sharedService,Residents,RoomDetails,_gStaffResidentData)
{

              let jObj = JSON.parse(data);
              if(jObj != null)
              {
                var roomId = jObj['Value']['RoomId'];
                var lastRoomId = jObj['Value']['LastRoomId'];
                var tagId = jObj['Value']['TagId'];
                var lastRoomUpdatedOn = jObj['Value']['LastRoomUpdatedOn'];
                var updatedOn = jObj['Value']['UpdatedOn'];
                var lastRoomName="";
            
                var lastRoomDeviceType = "";
                if(RoomDetails[lastRoomId] != null)
                {
                  lastRoomName = RoomDetails[lastRoomId][0].RoomName; 
                  lastRoomDeviceType  = RoomDetails[lastRoomId][0].DeviceTypeId;             
                }

                var preRoomName="";
                var RoomDeviceTypeId=1;
                if(RoomDetails[roomId] != null)
                {
                  preRoomName = RoomDetails[roomId][0].RoomName;
                  RoomDeviceTypeId = RoomDetails[roomId][0].DeviceTypeId;
                };

                if(lastRoomName == "")
                {
                  lastRoomName = preRoomName;
                }

                if(lastRoomId == null ||lastRoomId == 0 )
                    lastRoomId = roomId;               

                var Photo = "";
                var Type = 2;
                var objstaffresident;
                var _objstaffresident;

                var IsDataexists = 1;
                if(_gStaffResidentData != null)
                {
                  
                  _gStaffResidentData = _gStaffResidentData.filter(function (e1) {
                    if(e1.TagId == tagId)
                    {
                      e1.RoomId=roomId+'_'+RoomDeviceTypeId;
                      e1.LastRoomId=lastRoomId;
                      e1.UpdatedTime=updatedOn;                      
                      e1.LastRoomName=lastRoomName;
                      e1.RoomName=preRoomName;
                      IsDataexists = 0;
                    }
                    return e1.TagId;
                  });
                    objstaffresident = _gStaffResidentData.filter(function (e1) {
                          return e1.TagId == tagId;
                    });

                  
                  _sharedService.changeSharedResidentStaffBased(_gStaffResidentData);

                  var ResidentsStaff = groupBy(_gStaffResidentData, 'RoomId');
                 

                  if(ResidentsStaff[lastRoomId+"_"+lastRoomDeviceType] != null)
                  {
                    for(var x = 0; x<ResidentsStaff[lastRoomId+"_"+lastRoomDeviceType].length;x++)
                    {
                      if(ResidentsStaff[lastRoomId+"_"+lastRoomDeviceType][x].TagId == tagId) {
                        ResidentsStaff[lastRoomId+"_"+lastRoomDeviceType][x].splice(x, 1);
                        break;
                      }
                    }
                  }
                  _sharedService.changeResidentStaff(ResidentsStaff);

                    _objstaffresident=JSON.parse(JSON.stringify(objstaffresident));
                    if(objstaffresident != null)
                    {
                        if(objstaffresident.length > 0)
                        {
                              Photo = objstaffresident[0].Photo;
                              Type = objstaffresident[0].Type;
                        }
                    }
                    
                      _objstaffresident[0].PreRoomId=parseInt(roomId);
                      _objstaffresident[0].LastRoomId=parseInt(lastRoomId);
                      _objstaffresident[0].LastRoomUpdatedOn=lastRoomUpdatedOn;
                      _objstaffresident[0].DeviceType=RoomDeviceTypeId;
              
                    DrawLocation(_sharedService,_objstaffresident[0]);//lastRoomId, roomId, photo , tagId, lastRoomUpdatedOn
                }
              }

}
